/* template */
<template><div :class='("coupon-price "+(numberDigit)+" "+(type))'><span class="integer">{{valueObj.integer}}</span><span class="point" v-if="(valueObj.point)">{{valueObj.point}}</span><span class="decimal">{{valueObj.decimal}}</span><div class="desc"><div class="tip">{{ tip }}</div><span class="unit">{{ couponInfo.max_benefit_capacity.unit }}</span></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1a5d7eaf"}'>
.coupon-price
  position relative
  font-size: 80rpx;
  font-family: DIN-Bold, DIN-Bold-self;
  color: #ffffff;
  // text-shadow: 1px 1px 0px #FFFFFF;
  line-height 1
  display: flex;
  align-items: center;
  justify-content: center;
  height 100%
  &.digit-3
    .point
      margin-left 0
      margin-right -8rpx
    .integer
      letter-spacing: -4rpx;
  &.popup-result
    font-size 80rpx
    &.digit-3
      font-size 76rpx
      .tip
        margin-bottom: 12rpx
    .tip
      margin-bottom: 20rpx
  .point
    margin-left -4rpx
    margin-right -14rpx
  .desc
    display flex
    flex-direction column
  .unit
    font-size: 30rpx;
    font-family: PingFang SC;
    font-weight: 800;
    color: #ffffff;
    position relative
    right: -8rpx
  .tip
    text-shadow: none
    width: 48rpx;
    height: 23rpx;
    background: #ffffff;
    border-radius: 11px 11px 11px 0px;
    box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.7);
    font-size: 16rpx;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #FF5340;
    text-align center
    line-height 23rpx
    margin-bottom: 24rpx
    margin-left 8rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1a5d7eaf"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon-price-cz.mpx.js?isComponent&outputPath=components%2Fcoupon-price-cz1a5d7eaf%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./coupon-price-cz.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcoupon-price-cz1a5d7eaf%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1a5d7eaf"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon-price-cz1a5d7eaf/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
